import { handleActions } from 'redux-actions';
import {
  FETCH_ACCOUNT_SUCCESSED,
  FETCH_PENDING,
  FETCH_SUCCESSED,
  FETCH_BLOCKS_SUCCESSED,
  FETCH_PAYMENTS_SUCCESSED,
  FETCH_MINERS_SUCCESSED,
  FETCH_ACCOUNT_FAILED,
  FETCH_COINS_SUCCESSED,
  FETCH_SINGLE_SUCCESSED,
  FETCH_TOTAL_AMOUNT_SUCCESSED,
  POST_SETTINGS_FAILED,
  POST_SETTINGS_SUCCESSED,
  UPDATE_SETTINGS,
  SETTINGS_SET_FOCUS,
  TEMPLATES_SET_CURRENT, TEMPLATES_UPDATE_PLACEHOLDER,
} from './actions';

const placeholderRegexp = /#([^:#]{1,}):([^:#]{1,})#/g;

const initialState = {
  list: [],
  data: null,
  pending: false,
  error: null,
  blocks: null,
  payments: null,
  miners: null,
  account: null,
  accountError: null,
  coins: null,
  totalPayments: null,

  isSettingsErrorInternal: false,
  hasSettingsError: false,
  settingsError: null,
  settingsErrorInfo: '',
  isSettingsSucceed: false,

  settings: {
    focused: -1,
    threshold: {
      ip: '',
      amount: 0
    }
  },
  templates: {
    curTemplate: null,
    content: [],
    placeholders: {}
  }
};

export default handleActions(
  {
    [FETCH_PENDING]: state => ({
      ...state,
      pending: true,
      error: null,
      accountError: false,
    }),
    [FETCH_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      list: payload,
      error: null,
    }),
    [FETCH_SINGLE_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      data: payload,
      error: null,
    }),
    [FETCH_COINS_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      coins: payload.coins,
      error: null,
    }),
    [FETCH_TOTAL_AMOUNT_SUCCESSED]: (state, { payload }) => ({
      ...state,
      totalPayments: payload,
    }),
    [FETCH_BLOCKS_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      blocks: payload,
      error: null,
    }),
    [FETCH_PAYMENTS_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      payments: payload,
      error: null,
    }),
    [FETCH_MINERS_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      miners: payload,
      error: null,
    }),
    [FETCH_ACCOUNT_FAILED]: state => ({
      ...state,
      pending: false,
      miners: null,
      accountError: true,
    }),
    [FETCH_ACCOUNT_SUCCESSED]: (state, { payload }) => {
      let nState = {
        ...state,
        pending: false,
        account: payload,
        accountError: false,
        error: null,
      };
      if (!nState.settings.threshold.amount && payload) {
        nState.settings.threshold.amount = payload.payoutThreshold;
      }
      return nState;
    },
    [POST_SETTINGS_FAILED]: (state, { payload }) => ({
      ...state,
      pending: payload.isInternal ? state.pending : false,
      hasSettingsError: true,
      isSettingsErrorInternal: Boolean(payload.isInternal),
      settingsError: payload.error || "ERROR_UNKNOWN",
      settingsErrorInfo: payload.info || '',
      isSettingsSucceed: false
    }),
    [POST_SETTINGS_SUCCESSED]: (state, { payload }) => ({
      ...state,
      pending: false,
      settingsError: null,
      hasSettingsError: false,
      isSettingsErrorInternal: false,
      settingsErrorInfo: '',
      isSettingsSucceed: !(payload && payload.reset)
    }),
    [UPDATE_SETTINGS]: (state, { payload }) => ({
      ...state,
      settings: {
        ...payload
      }
    }),
    [SETTINGS_SET_FOCUS]: ({ settings, ...state }, { payload }) => ({
      ...state,
      settings: {
        ...settings,
        focused: payload
      }
    }),
    [TEMPLATES_SET_CURRENT]: (state, { payload: curTemplate }) => {
      if (!state.data?.templates || !curTemplate) {
        return {
          ...state,
          templates: {
            curTemplate: null,
            content: [],
            placeholders: {}
          }
        };
      }
      const template = state.data.templates.find(template => template.slug === curTemplate)
      if (!template) {
        return {
          ...state,
          templates: {
            curTemplate: null,
            content: [],
            placeholders: {}
          }
        };
      }

      const placeholdersMatch = template.content.matchAll(placeholderRegexp)

      const content = [];
      const placeholders = {};
      let prevIdx = 0;

      for (const match of placeholdersMatch) {
        if (match.length < 3) {
          console.error('Placeholders must be in form #id:type#, got', match);
          continue;
        }

        const placeholder = {
          id: match[1],
          type: match[2].toLowerCase(),
          content: '',
          contentIdx: 0,
        };
        let initPhContent = '';
        switch (placeholder.type) {
          case 'server':
            initPhContent = placeholder.content = state.data.servers && state.data.servers.length > 0 ? state.data.servers[0].ip : '';
            break;
          case 'wallet':
            placeholder.content = '';
            initPhContent = 'YOUR_WALLET';
            break;
          case 'worker':
            placeholder.content = '';
            initPhContent = 'WORKER_NAME';
            break;
        }

        const textBeforePlaceholder = match.input.substring(prevIdx, match.index);
        prevIdx = match.index + match[0].length;
        const contentLength = content.push(textBeforePlaceholder, initPhContent);
        placeholder.contentIdx = contentLength-1;
        placeholders[placeholder.id] = placeholder;
      }
      if (template.content.length > prevIdx) {
        content.push(template.content.substring(prevIdx));
      }

      return {
        ...state,
        templates: {
          curTemplate,
          content,
          placeholders,
        },
      }
    },
    [TEMPLATES_UPDATE_PLACEHOLDER]: (state, { payload }) => {
      if (!state.templates.placeholders.hasOwnProperty(payload.id) || state.templates.placeholders[payload.id].content === payload.newContent) {
        return state;
      }
      const {templates, ...restState} = state;
      const content = window.structuredClone(templates.content);
      const placeholders = window.structuredClone(templates.placeholders);
      const {id, newContent} = payload;

      const placeholder = placeholders[id];
      if (!newContent) {
        placeholder.content = '';
        let phContent = '';
        switch (placeholder.type) {
          case 'wallet':
            phContent = 'YOUR_WALLET';
            break;
          case 'worker':
            phContent = 'WORKER_NAME';
            break;
        }
        content[placeholder.contentIdx] = phContent;
      } else {
        content[placeholder.contentIdx] = placeholder.content = newContent;
      }
      return {
        ...restState,
        templates: {
          ...templates,
          content,
          placeholders
        }
      }
    }
  },
  initialState
);
